<mat-progress-bar class="main-loader" mode="indeterminate" *ngIf="this.appConfig.mainLoading"></mat-progress-bar>
<router-outlet></router-outlet>
